export const CATEGORIES = [
  {
    slug: "forskning",
    title: "Forskning",
    text: "Forskningsartikler og studier, som vi har bidraget til, inden for blandt andet traumer, traumereaktioner, PTSD, kompleks PTSD, psykoterapi og psykometri.",
    items: [
      {
        title: "Psykometriske egenskaber ved PTSD-skalaen i International Trauma Questionnaire (ITQ)",
        url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC12885006/",
        meta: "Forskningsartikel · European Journal of Psychotraumatology · december 2025",
        date: "2025-12",
        description:
          "Sabrina Brødsgaard Nielsen har sammen med medforfatterne undersøgt, hvilken betydning forskellige måder at opgøre items i PTSD-skalaen i International Trauma Questionnaire (ITQ) har for skalaens psykometriske egenskaber og muligheden for at identificere differentiel itemfunktion (DIF). I studiet sammenlignes dikotomisering af items med bevarelse af de polytome svar, og det undersøges, hvilken betydning valget kan have for både forskningsresultater og klinisk anvendelse.",
        linkLabel: "Læs forskningsartiklen",
        image: null,
        authors: [
          {
            name: "Tine Nielsen",
            affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet · UCL Erhvervsakademi og Professionshøjskole",
          },
          { name: "Ask Elklit", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
          { name: "Sabrina Brødsgaard Nielsen", affiliation: null },
          { name: "Mikkel Auning-Hansen", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Svend Kreiner", affiliation: "Københavns Universitet" },
          { name: "Maria Louison Vang", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
        ],
      },
      {
        title: "Betydningen af livsomstændigheder for behandlingsudbytte",
        url: "https://tidsskrift.dk/torture-journal/article/view/97208",
        meta: "Forskningsartikel · Torture Journal · december 2017",
        date: "2017-12",
        description:
          "Sabrina Brødsgaard Nielsen har sammen med medforfatterne undersøgt sammenhænge mellem funktionsniveau, livsomstændigheder og behandlingsudbytte blandt 81 behandlingssøgende mennesker med flugterfaring.\n\nI modsætning til resultater fra mange andre studier var det at leve med en partner forbundet med et dårligere behandlingsudbytte. Der er tale om en gruppe, hvor flere medlemmer af familien ofte lever med traumereaktioner og komplekse sociale livssituationer.\n\nStudiet peger dermed på betydningen af helhedsorienterede indsatser og inddragelse af pårørende. Et snævert, klassisk vestligt og individorienteret fokus kan være begrænsende, når menneskers reaktioner, relationer og livsomstændigheder er tæt forbundne.",
        linkLabel: "Læs forskningsartiklen i Torture Journal",
        image: null,
        authors: [
          { name: "Sabrina Brødsgaard Nielsen", affiliation: null },
          { name: "Mikkel Auning-Hansen", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Ask Elklit", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
        ],
      },
      {
        title: "Traumatiske oplevelser og traumereaktioner blandt børn og unge i den danske folkeskole",
        url: "https://onlinelibrary.wiley.com/doi/10.1111/sjop.13079",
        meta: "Forskningsartikel · Scandinavian Journal of Psychology · november 2024",
        date: "2024-11",
        description:
          "Sabrina Brødsgaard Nielsen har sammen med en gruppe medforfattere undersøgt de psykometriske egenskaber ved screeningsredskabet International Trauma Questionnaire – Child and Adolescent Version (ITQ-CA) samt forekomsten af traumatiske oplevelser, PTSD og kompleks PTSD blandt 226 børn og unge fra folkeskoler på Fyn og i Jylland.\n\nBlandt børnene og de unge var traumatiske oplevelser mere reglen end undtagelsen. Blandt de hyppigt rapporterede oplevelser var mobning, trusler om vold og seksuelle krænkelser, ligesom mange beskrev mangel på varme og omsorg i hjemmet.\n\nResultaterne understreger betydningen af ikke at arbejde ud fra en for snæver definition af, hvilke oplevelser der kan være traumatiske, og af at forstå børn og unges traumereaktioner i en bredere og helhedsorienteret sammenhæng.",
        linkLabel: "Læs forskningsartiklen",
        image: null,
        authors: [
          { name: "Katla Sigurðardóttir", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Noor Qambar", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Ask Elklit", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
          { name: "Mikkel Auning-Hansen", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Sabrina Brødsgaard Nielsen", affiliation: null },
        ],
      },
      {
        title: "Tværkulturel validitet af International Trauma Questionnaire (ITQ)",
        url: "https://www.tandfonline.com/doi/full/10.1080/20008066.2023.2172256",
        meta: "Forskningsartikel · European Journal of Psychotraumatology · februar 2023",
        date: "2023-02",
        description:
          "Sabrina Brødsgaard Nielsen har sammen med en gruppe forskere undersøgt den tværkulturelle validitet og de psykometriske egenskaber ved International Trauma Questionnaire (ITQ) blandt 490 behandlingssøgende mennesker med flugterfaring.\n\nStudiet omfattede danske, arabiske og bosniske sprogversioner samt forskellige grader af brug af tolk. Resultaterne viste blandt andet, at skalaernes psykometriske egenskaber var stabile på tværs af de tre sprog og forskellige grader af tolkebistand, mens enkelte items fungerede forskelligt afhængigt af blandt andet køn og tid siden den traumatiske oplevelse.",
        linkLabel: "Læs forskningsartiklen",
        image: null,
        authors: [
          {
            name: "Tine Nielsen",
            affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet · UCL Erhvervsakademi og Professionshøjskole",
          },
          { name: "Ask Elklit", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
          { name: "Maria Louison Vang", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
          { name: "Sabrina Brødsgaard Nielsen", affiliation: null },
          { name: "Mikkel Auning-Hansen", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Sabina Palic", affiliation: "DIGNITY – Danish Institute Against Torture" },
        ],
      },
      {
        title: "PTSD og kompleks PTSD blandt mennesker med flugterfaring",
        url: "https://tidsskrift.dk/torture-journal/article/view/115367",
        meta: "Forskningsartikel · Torture Journal · 2020",
        date: "2020-01",
        description:
          "Sabrina Brødsgaard Nielsen har sammen med medforfatterne undersøgt traumereaktioner blandt 284 behandlingssøgende mennesker med flugterfaring.\n\nVed hjælp af latent class analysis blev det undersøgt, om der i deltagernes traumereaktioner kunne identificeres forskellige mønstre svarende til ICD-11's diagnostiske forståelsesrammer for PTSD og kompleks PTSD. Analysen identificerede blandt andet en langt større gruppe med et reaktionsmønster svarende til kompleks PTSD end PTSD.",
        linkLabel: "Læs forskningsartiklen i Torture Journal",
        image: null,
        authors: [
          { name: "Maria Louison Vang", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
          { name: "Sabrina Brødsgaard Nielsen", affiliation: null },
          { name: "Mikkel Auning-Hansen", affiliation: "RehabiliteringsCenter for Traumatiserede" },
          { name: "Ask Elklit", affiliation: "Videnscenter for Psykotraumatologi, Syddansk Universitet" },
        ],
      },
    ],
  },
  {
    slug: "debat-og-medier",
    title: "Debat & medier",
    text: "Debatindlæg, kronikker, interviews og andre bidrag til den offentlige og faglige samtale om menneskers trivsel og psykiske lidelse, traumereaktioner, behandling og de forståelser og systemer, mennesker mødes af.",
    items: [
      {
        title: "Når diagnoser skaber afstand mellem ”os og dem”, følger diskriminationen",
        url: "https://jyllands-posten.dk/debat/kronik/ECE18549663/naar-diagnoser-skaber-afstand-mellem-os-og-dem-foelger-diskriminationen/",
        meta: "Kronik · Jyllands-Posten · Anders Sørensen · september 2025",
        date: "2025-09",
        linkLabel: "Læs kronikken i Jyllands-Posten",
        image: "/brand/debat-diagnoser-jp.jpg",
      },
      {
        title: "Det viser sig sværere at trappe ud af medicinen, end man troede. Det er altså ikke lægernes skyld",
        url: "https://politiken.dk/debat/debatindlaeg/art10934314/Det-viser-sig-sv%C3%A6rere-at-trappe-ud-af-medicinen-end-man-troede.-Det-er-alts%C3%A5-ikke-l%C3%A6gernes-skyld",
        meta: "Debatindlæg · Politiken · Anders Sørensen · august 2026",
        date: "2026-08",
        linkLabel: "Læs debatindlægget i Politiken",
        image: "/brand/debat-udtrapning-pol.png",
      },
      {
        title: "Antidepressiva: Når forskningen bevæger sig hurtigere end retningslinjerne",
        url: "https://www.dagensmedicin.dk/debat/opinion/antidepressiva-nar-forskningen-bevaeger-sig-hurtigere-end-retningslinjerne/",
        meta: "Debatindlæg · Dagens Medicin · Anders Sørensen · februar 2026",
        date: "2026-02",
        linkLabel: "Læs debatindlægget i Dagens Medicin",
        image: "/brand/debat-antidepressiva.jpg",
      },
      {
        title: "Eksplosionen af børn på psykofarmaka bør få alarmklokkerne til at ringe",
        url: "https://www.information.dk/debat/2026/09/eksplosionen-boern-paa-psykofarmaka-boer-faa-alarmklokker-ringe",
        meta: "Debatindlæg · Dagbladet Information · Sabrina B. Nielsen · september 2026",
        date: "2026-09",
        linkLabel: "Læs debatindlægget i Dagbladet Information",
        image: "/brand/debat-psykofarmaka.jpg",
      },
      {
        title: "Når et navn bliver en trigger",
        url: "https://www.kristeligt-dagblad.dk/danmark/naar-heidi-hoerer-sit-navn-bliver-hun-skamfuld-og-bange-men-hun-vil-ikke-aendre-det-jeg",
        meta: "Interview · Kristeligt Dagblad · Sabrina B. Nielsen · juli 2026",
        date: "2026-07",
        linkLabel: "Læs artiklen i Kristeligt Dagblad",
        image: "/brand/debat-navn-trigger.jpg",
      },
      {
        title: "MDMA-assisteret terapi og forståelsen af psykisk lidelse",
        url: "https://nyheder.tv2.dk/samfund/2026-09-10-hun-modtog-ulovlig-behandling-som-professor-vurderer-kan-vaere-lovlig-om-to-aar",
        meta: "Interview · TV 2 Nyheder · Sabrina B. Nielsen og Helena Dahl Bendixen · september 2026",
        date: "2026-09-10",
        linkLabel: "Læs artiklen hos TV 2 Nyheder",
        image: "/brand/debat-mdma.jpg",
      },
    ],
  },
  {
    slug: "levede-erfaringer",
    title: "Levede erfaringer",
    text: "Vidnesbyrd, digte, fortællinger og andre bidrag fra mennesker med levede erfaringer, der giver indblik i mødet med vores forståelser, praksisser og systemer.",
    items: [
      {
        title: "Mælkebøttebørn",
        kind: "text",
        meta: "Digt · Jimmy Gørtz",
        description:
          "Mange ”brændte børn” opfører sig som mælkebøtten.\n\nDe finder fodfæste i samfundet til trods for, at de har rødder i deres traumer.\n\nSamfundet har set dem som lukkede, utilnærmelige eller utilpassede. Intet kunne være mere usandt.\n\nDe brændte børn lukker sig om sig selv, fordi de ikke har tillid til samfundet eller voksne.\n\nDe er hårdføre som mælkebøtten, for de har lært af få næring hvor ingen næring er. De har lært at overleve uden at kende til kærlighed og tryghed.\n\nMælkebøttebørn er ikke forkerte børn. Mælkebøttebørn er børn der har overlevet på trods af, at samfundet aldrig har lært at lytte til det de ikke siger.\n\nMælkebøttebørn er lukkede, fordi de er loyale overfor dem, der fylder dem med traumer.\n\nJeg ved det, for jeg lever med det hver dag i de lyse såvel som i de mørke timer.",
        byline: "Jimmy Gørtz: mønsterbryder, forfatter, digter, foredragsholder",
      },
      {
        title: "Mit navn",
        kind: "text",
        meta: "Digt · Jimmy Gørtz · Fra digtsamlingen ”Nogen gange så gemmer jeg mig” · 2022",
        description:
          "Du bestemte mit navn,\nhvilket præsten forkyndte ved min dåb.\nDog valgte du ikke at bruge det\ni din omgang med mig som menneske.\n\nMit navn havde ingen betydning.\nDu piftede, når jeg skulle komme.\nDu brugte aldrig mit navn, når du kaldte -\ndu brølede bare dine ordre.\n\nHvorfor gav du mig et navn,\nNår det ikke skulle bruges?\nHvorfor ville du have et barn,\nnår du behandlede mig som en hund?\n\nDu lærte mig så meget -\nsom at forudse dine ønsker og behov.\nDu lærte mig også\naltid at sove utrygt og være på vagt.\n\nDen viden og erfaring\nbærer jeg med mig i dag.\nDen er i min rygsæk\nI form af smerte fra alle dine slag.\n\nJeg har lært og følt,\nat min plads ikke er i solen.\nJeg har lært at indse,\nat magten har den, som sidder i stolen.",
        byline: "Jimmy Gørtz: mønsterbryder, forfatter, digter, foredragsholder",
      },
    ],
  },
  {
    slug: "se-og-lyt",
    title: "Se & lyt",
    text: "Podcasts, TV, radio, videoer, samtaler og optagede oplæg, hvor faglige og erfaringsbaserede perspektiver formidles og bringes i dialog.",
    items: [
      {
        title: "MDMA-assisteret terapi, traumer og rammer",
        url: "https://play.tv2.dk/serie/go-morgen-danmark-tv2/new-zealand-tillader-mdma-terapi-mod-ptsd-44d896b7-4c02-4cbe-9816-d01d8ee8098a",
        meta: "Go' Morgen Danmark · TV 2 · september 2026",
        date: "2026-09",
        description:
          "Sabrina Brødsgaard Nielsen og Helena Dahl Bendixen deltager i Go' Morgen Danmark i en samtale om MDMA-assisteret terapi for PTSD. Samtalen handler ikke alene om en ny behandlingsform, men om de forståelser og rammer, mennesker med traumereaktioner mødes med: Hvad sker der, når forældede forståelser og behandlingsformer er dominerende, og fokus primært er rettet mod at dæmpe reaktioner frem for at forstå, hvad de er reaktioner på? Og hvordan skaber vi rammer og sikkerhed for de mennesker, som allerede nu løber en risiko ved at opsøge MDMA-assisteret terapi uden for det etablerede system?",
        linkLabel: "Se indslaget hos TV 2",
        image: "/brand/se-og-lyt-gmd.jpg",
        caption: "Sabrina Brødsgaard Nielsen og Helena Dahl Bendixen i Go' Morgen Danmark",
      },
      {
        title: "Bag terapiens lukkede døre",
        url: "https://open.spotify.com/show/0HCcpqnUpMFgvrqb2JlyEz",
        meta: "Podcast · Mads Dahlgaard · 2026",
        date: "2026",
        description:
          "Bag terapiens lukkede døre inviterer lytteren med ind i terapirummet gennem autentiske terapisamtaler. Her er der plads til både klientens oplevelser og terapeutens tvivl, følelser og faglige overvejelser.\n\nEfter samtalerne følger faglige analyser og refleksioner over det, der opstod i terapien. Podcasten åbner dermed en dør til en verden, som ellers ofte er forbeholdt terapeuter, og gør viden om psykoterapi og terapeutisk praksis tilgængelig for flere.",
        linkLabel: "Lyt til Bag terapiens lukkede døre på Spotify",
        image: "/brand/se-og-lyt-bag-terapiens.jpg",
        imageSize: "small",
      },
      {
        title: "Noget I bør vide",
        url: "https://open.spotify.com/show/2Ycd7YAA0uARBCAp2fRg7f",
        meta: "Podcast · Anders Sørensen",
        description:
          "Noget I bør vide er en samtalepodcast om psykologi, mental sundhed, mistrivsel og psykisk lidelse – og om de meget menneskelige måder, vi forsøger at håndtere livet på, når det bliver svært. Podcasten giver plads til perspektiver, der ofte mangler i den offentlige debat: om følelser, relationer, krop, medicin, diagnoser og de systemer, vi møder, når vi får det svært. Samtalerne bevæger sig mellem personlige erfaringer og faglig viden og undersøger, hvordan vi kan forstå psykisk lidelse mere nuanceret. Vært er psykolog og ph.d. i psykiatri Anders Sørensen.",
        links: [
          { label: "Lyt på Spotify", url: "https://open.spotify.com/show/2Ycd7YAA0uARBCAp2fRg7f" },
          {
            label: "Lyt på Apple Podcasts",
            url: "https://podcasts.apple.com/dk/podcast/noget-i-b%C3%B8r-vide-med-anders-s%C3%B8rensen/id1884692988?l=da",
          },
        ],
        image: "/brand/se-og-lyt-noget-i-boer-vide.jpg",
      },
    ],
  },
  {
    slug: "boeger-og-publikationer",
    title: "Bøger & publikationer",
    text: "Bøger og andre faglige udgivelser, som vi har skrevet eller bidraget til.",
    items: [
      {
        title: "Noget I bør vide... Om udtrapning af psykofarmaka",
        url: "https://www.psykologanders.dk/b%C3%B8ger.html",
        meta: "Bog · Anders Sørensen · 2024",
        date: "2024-01",
        description:
          "Noget I bør vide... Om udtrapning af psykofarmaka henvender sig både til mennesker, der selv skal trappe ud af psykofarmaka, og til fagpersoner, der arbejder med mennesker i udtrapning.\n\nBogen formidler forskningsbaseret viden om psykofarmaka, psykisk lidelse og udtrapning. Den giver konkret og brugbar vejledning i, hvordan man trapper langsomt og sikkert ud, og hvordan man undervejs håndterer faldgruber og abstinenser som angst, følelsesmæssige udsving og fysiske symptomer.\n\nEn stor del af bogen handler også om, hvordan man håndterer vanskelige følelser, tankemylder og andre psykiske udfordringer i et efterfølgende medicinfrit liv. Her inddrages redskaber fra metakognitiv terapi, emotionsreguleringsterapi og traumeorienterede tilgange, som er blevet videreudviklet til udtrapningsprocessen.",
        linkLabel: "Læs mere om bogen",
        image: "/brand/bog-udtrapning.png",
        imageSize: "small",
      },
      {
        title: "Sådan bliver du en bedre terapeut",
        url: "https://www.saxo.com/dk/saadan-bliver-du-en-bedre-terapeut_bog_9788797071175",
        meta: "Fagbog · Mads Dahlgaard og Mahdi Majid · januar 2025",
        date: "2025-01",
        description:
          "Sådan bliver du en bedre terapeut henvender sig til mennesker, der arbejder seriøst med psykoterapi og ønsker at udvikle deres terapeutiske kompetencer gennem målrettet færdighedstræning.\n\nBogen tager afsæt i psykoterapiforskning og undersøger, hvordan terapeuter kan dygtiggøre sig. Den introducerer blandt andet til helping skills, deliberate practice og konkrete metoder til træning og evaluering af terapeutiske færdigheder.\n\nBogen kombinerer forskning med praktiske tilgange til kompetenceudvikling og giver et indblik i både mulighederne og udfordringerne ved systematisk at arbejde med udviklingen af egen terapeutisk praksis.",
        linkLabel: "Læs mere om bogen",
        image: "/brand/bog-terapeut.jpg",
        imageSize: "small",
      },
    ],
  },
  {
    slug: "vaerktoejer-og-materialer",
    title: "Værktøjer & materialer",
    text: "Modeller, refleksionsmaterialer, guides og andre redskaber, der kan bruges til læring, refleksion og udvikling af praksis.",
  },
  {
    slug: "andre-udvalgte-ressourcer",
    title: "Andre udvalgte ressourcer",
    text: "Forskning, rapporter, bøger, organisationer, podcasts og andre ressourcer, som vi ikke selv står bag, men som kan bidrage med relevante perspektiver og viden.",
    items: [
      {
        title: "Anbefalinger til traumebevidst tilgang",
        url: "https://www.sbst.dk/udgivelser/2023/anbefalinger-til-at-arbejde-traumebevidst-i-den-sociale-indsats-med-voksne-",
        meta: "Social- og Boligstyrelsen · 2023",
        date: "2023-01",
        description:
          "Social- og Boligstyrelsen har udarbejdet fire anbefalinger til traumebevidst arbejde med voksne i sociale indsatser. Anbefalingerne har fokus på viden og kompetencer, borgerens egne perspektiver, tillid og tryghed samt de fysiske rammer og rummer også organisatoriske råd til implementeringen.",
        linkLabel: "Se anbefalingerne hos Social- og Boligstyrelsen",
        image: null,
      },
      {
        title: "Traumebevidste tilgange i sociale indsatser",
        url: "https://www.vive.dk/da/udgivelser/viden-om-traumebevidste-tilgange-i-indsatser-til-socialt-udsatte-voksne-4z6ryrzq/",
        meta: "VIVE · Vidensafdækning og prototype · 2022",
        date: "2022-01",
        description:
          "VIVE samler dansk og international viden om traumebevidste tilgange i arbejdet med voksne i social udsathed. På baggrund af vidensafdækningen har VIVE udviklet en prototype for traumebevidst tilgang med seks kerneelementer med fokus på blandt andet viden om traumer, tillid og tryghed, borgerens ejerskab, tværfagligt samarbejde og organisatorisk implementering som en længerevarende forandringsproces.",
        linkLabel: "Læs vidensafdækningen og se VIVEs prototype",
        image: null,
      },
      {
        title: "Landsforeningen for PTSD-ramte og pårørende",
        url: "https://lptsd.dk/",
        meta: "Viden, støtte og fællesskaber",
        description:
          "Landsforeningen for PTSD-ramte og pårørende tilbyder viden og støtte til mennesker med traumereaktioner samt deres pårørende. Hos foreningen kan man også finde fællesskaber og muligheder for at møde andre med egne eller pårørendeerfaringer.",
        linkLabel: "Besøg Landsforeningen for PTSD-ramte og pårørende",
        image: null,
      },
    ],
  },
];
